// fork overlay: fork-owned new settings route — EVA-M6.
// Registers /settings/eva → the Eva assistants settings page. Alias-form imports (D-07) so the
// overlay plugin resolves the fork page component. Admin-only.
import { frontendURL } from 'dashboard/helper/URLHelper';
import SettingsWrapper from 'dashboard/routes/dashboard/settings/SettingsWrapper.vue';
import AssistantSettings from 'dashboard/components-next/Eva/AssistantSettings.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/eva'),
      component: SettingsWrapper,
      props: {
        headerTitle: 'EVA_ASSISTANT_SETTINGS.PAGE_TITLE',
        icon: 'i-lucide-bot',
        showNewButton: false,
      },
      meta: { permissions: ['administrator'] },
      children: [
        {
          path: '',
          name: 'eva_assistant_settings_index',
          component: AssistantSettings,
          meta: { permissions: ['administrator'] },
        },
      ],
    },
  ],
};
